import React from 'react';
import Footer from '@/components/layout/Footer';

interface HomeLayoutProps {
  children: React.ReactNode;
  hideFooter?: boolean;
}

const HomeLayout = React.memo(({ children, hideFooter = false }: HomeLayoutProps) => {
  return (
    <div className="min-h-screen">
      {children}
  {!hideFooter && <Footer />}
    </div>
  );
});

HomeLayout.displayName = 'HomeLayout';

export default HomeLayout;